import { ref,watch } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import ReportOptions from '@/views/reports/components/options.js'
import data from '@/router/routes/ui-elements'
import { useUtils as useI18n } from '@core/libs/i18n'

const { defaultFromdate, defaultTodate } = ReportOptions()

export default function DistanceReportLogic() {
  const { t } = useI18n()
 
  const request = ref({
    page: 1,
    length: 25,
    type: 'distance',

    from: defaultFromdate,
    to: defaultTodate,

  })

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const  dataTableloading=ref(false)
const days_label=ref(t('Number Of Days'))
  const getReport = () => {

    errors.value = {}
    loading.value = true

    ReportService.getReport(request.value)

      .then(res => {
        report_data.value =res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => loading.value = false)
  }

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  
  watch([sortBy,isSortDirDesc],()=>{
  
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    dataTableloading.value = true

    ReportService.getReport(request.value)

      .then(res => {
        report_data.value =res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => dataTableloading.value = false)
  })

  const setRowSummery = (data) => {   
    let new_data = [];
    let current_device = "";
    let total_distance = 0;
    let days_counter = 0;

    for (let i = 0; i < data.length; i++) {
      if (current_device == "") {
        current_device = data[i].device_name;
      }

      if (current_device == data[i].device_name) {
        days_counter += 1;
        total_distance += parseFloat(data[i].distance);
        new_data.push({
          id:i+1,
          contractor_name: data[i].contractor_name,
          contract: data[i].contract,
          device_name: data[i].device_name,
          d_date: data[i].date,
          distance: data[i].distance
        }
        )

        if (data[i + 1] != undefined && data[i + 1].device_name != current_device) {
          new_data.push({id:'#', contract: data[i].contract, contractor_name: data[i].contractor_name, device_name: data[i].device_name, d_date: days_label.value+"  "+days_counter, groupRow: true, "distance": total_distance.toFixed(2) + "km" })
          total_distance = 0; current_device = ""; days_counter = 0;
        } else if (i + 1 == data.length) {
          new_data.push({id:'#', contract: data[i].contract, contractor_name: data[i].contractor_name, device_name: data[i].device_name, d_date: days_label.value+"  "+days_counter, groupRow: true, "distance": total_distance.toFixed(2) + "km" })
        }
      }


    }

    return new_data;
  }




  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.exportReport({
        ...Object.assign(request.value, {
          page: '', length: ''
        }), length: 50000
      }).then(res => r(res.data.data))
        .finally(() => loading.value = false)
    })
  }


  return {
    getReport, getReportForPdf,
    report_data,
    total, from, to,
    request,
    loading,
    errors,
    isSortDirDesc,sortBy,dataTableloading
  }
}
